import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_HALAL_STOCK_PRICE_HISTORY } from "../../../config/api";

export const getStockPriceHistory = createAsyncThunk(
  "stocks/priceHistory",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: API_HALAL_STOCK_PRICE_HISTORY(id),
      });

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
